import jwtDecode from 'jwt-decode';
import axios, { AxiosResponse } from 'axios';
import { useUser } from 'hooks/auth';

// import config from '../../config';
const isTokenExpired = (token: string): boolean => {
    try {
        const decoded: { exp: number } = jwtDecode(token);
        if (!decoded.exp) return true;

        const now = Math.floor(Date.now() / 1000); // current time in seconds
        return decoded.exp < now;
    } catch (e) {
        return true; // treat invalid tokens as expired
    }
};
// content type
axios.defaults.headers.post['Content-Type'] = 'application/json';
// axios.defaults.baseURL = config.API_URL;

// intercepting to capture errors
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        let message;

        if (error && error.response && error.response.status === 404) {
            // window.location.href = '/not-found';
        } else if (error && error.response && error.response.status === 403) {

            window.location.href = '/access-denied';
        } else {
            switch (error.response.status) {
                case 401:
                    message = 'Invalid credentials';
                    break;
                case 403:
                    message = 'Access Forbidden';
                    break;
                case 404:
                    message = 'Sorry! the data you are looking for could not be found';
                    break;
                default: {
                    message =
                        error.response && error.response.data ? error.response.data['message'] : error.message || error;
                }
            }
            return Promise.reject(message);
        }
    }
);

const AUTH_SESSION_KEY = 'shield_user';

const base_url = process.env.REACT_APP_API;

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: string | null) => {
    if (token) axios.defaults.headers.common['Authorization'] = 'JWT ' + token;
    else delete axios.defaults.headers.common['Authorization'];
};

const getUserFromCookie = () => {
    const user = localStorage.getItem(AUTH_SESSION_KEY);
    return user ? (typeof user == 'object' ? user : JSON.parse(user)) : null;
};



class APICore {

    /**
     * Fetches data from given url
     */
    get = async (url: string, params?: any) => {
        let response;
        if (params) {
            var queryString = params
                ? Object.keys(params)
                      .map((key) => key + '=' + params[key])
                      .join('&')
                : '';
            response = await axios.get(`${url}?${queryString}`, params);
        } else {
            response = axios.get(`${url}`, params);
        }
        return response;
    };

    onlyget = async (url:string)=>{
        let response;
        response = await axios.get(`${base_url+url}`);
        return response


    }

    getFile = (url: string, params: any) => {
        let response;
        if (params) {
            var queryString = params
                ? Object.keys(params)
                      .map((key) => key + '=' + params[key])
                      .join('&')
                : '';
            response = axios.get(`${url}?${queryString}`, { responseType: 'blob' });
        } else {
            response = axios.get(`${url}`, { responseType: 'blob' });
        }
        return response;
    };

    getMultiple = (urls: string, params: any) => {
        const reqs = [];
        let queryString = '';
        if (params) {
            queryString = params
                ? Object.keys(params)
                      .map((key) => key + '=' + params[key])
                      .join('&')
                : '';
        }

        for (const url of urls) {
            reqs.push(axios.get(`${url}?${queryString}`));
        }
        return axios.all(reqs);
    };

    /**
     * post given data to url
     */
    create = async (url: string, data: any) => {
        let dta=  await axios.post(base_url+url, data);
        return  dta
    };

     Lcreate = async (url: string, data: any, token:any) => {
        
        const response = await axios.post(base_url + url, data, {
      headers: {
        'Authorization': `Bearer ${token.data}`, // Set the Authorization header directly
        'Content-Type': 'application/json', // Set the content type as needed
      },
    });

        return  response
    };
     LcreateBlob = async (url: string, data: any, token: any, nameFile:any) => {
    try {
        const response: AxiosResponse<Blob> = await axios.post(base_url + url, data, {
            headers: {
                'Authorization': `Bearer ${token.data}`,
                'Content-Type': 'application/json',
            },
            responseType: 'blob',
        });

        // Check if the request was successful (status code 200-299)
        if (response.status >= 200 && response.status < 300) {
            const blob = response.data;
            const filename = nameFile+".xlsx"; // Adjust the filename as needed

            // Create a link element and trigger a click to download the file
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            return response; // You may choose to return the response if needed
        } else {
            // Handle error response
            const errorMessage = await response.data.text();
            console.error(`Error fetching data. Status: ${response.status}, Message: ${errorMessage}`);
            return response; // You may choose to handle errors in the calling code
        }
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error; // You may choose to handle errors in the calling code
    }
};


     Lonlyget = async (url:string, token:any)=>{
        let response;
        response = await axios.get(`${base_url+url}`,{
             headers: {
        'Authorization': `Bearer ${token.data}`, // Set the Authorization header directly
        'Content-Type': 'application/json', // Set the content type as needed
      },
        });
        return response


    }
   
   
    /**
     * Updates patch data
     */
    updatePatch = (url: string, data: any) => {
        return axios.patch(url, data);
    };

    /**
     * Updates data
     */
    update = (url: string, data: any) => {
        return axios.put(url, data);
    };

    /**
     * Deletes data
     */
    delete = (url: string) => {
        return axios.delete(url);
    };

    /**
     * post given data to url with file
     */
    createWithFile = (url: string, data: any) => {
        const formData = new FormData();
        for (const k in data) {
            formData.append(k, data[k]);
        }

        const config: any = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        return axios.post(url, formData, config);
    };

    /**
     * post given data to url with file
     */
    updateWithFile = (url: string, data: any) => {
        const formData = new FormData();
        for (const k in data) {
            formData.append(k, data[k]);
        }

        const config: any = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        return axios.patch(url, formData, config);
    };

    isUserAuthenticated = () => {
        const user = this.getLoggedInUser();

        if (!user) {
            return false;
        }
        return true;
       
         
    };

    setLoggedInUser = (session: any) => {
       if (session) {
        localStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(session));
         } else {
        localStorage.removeItem(AUTH_SESSION_KEY);
         }
    };
    /**
     * Returns the logged in user
     */
    getLoggedInUser = () => {
        return getUserFromCookie();
    };

    setUserInSession = (modifiedUser: any) => {
        let userInfo = localStorage.getItem(AUTH_SESSION_KEY);
        if (userInfo) {
            const { token, user } = JSON.parse(userInfo);
            this.setLoggedInUser({ token, ...user, ...modifiedUser });
        }
    };
}

/*
Check if token available in session
*/
let user = getUserFromCookie();

if (user?.data) {
    console.log('firdatast',user)
    const token = user.data;
    if (isTokenExpired(token)) {
        localStorage.removeItem(AUTH_SESSION_KEY);
        window.location.href = '/login';
    } else {
        setAuthorization(token);
    }
}
// console.log("Token:", user);
// console.log("Is expired:", isTokenExpired(user.token));


export { APICore, setAuthorization };
